import React, { Component } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import vMasker from 'vanilla-masker'
import { injectIntl, FormattedMessage } from 'react-intl'
import RawHtml from 'stories/components/RawHtml'
import {
  ensureEnglishNumber,
  toPersianDigit,
} from '../../../helpers/generalHelpers'
import './phone-number-input.css'

import settings from '../../../settings'
const { locales } = settings

class OtpPhoneNumberInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hasFocus: false, maskedValue: '' }
  }

  maskMobileNumber = (rawValue) => {
    return vMasker.toPattern(rawValue, '9999-9999999')
  }

  unMaskMobileNumber = (rawValue) => {
    return rawValue.replace('-', '')
  }

  onInputChange = (event) => {
    this.updateState({
      value: event.target.value,
      shouldUpdateParent: true,
    })
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => {
    // if not persian just don't proceed.
    if (!this.shouldApplyMasking()) return this.props.value

    // mobile input is not controlled
    return toPersianDigit(this.state.maskedValue)
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺 👍
    const { value } = this.props

    if (value) {
      this.updateState({
        value,
        shouldUpdateParent: false,
      })
    }
  }

  updateState = ({ value, shouldUpdateParent }) => {
    // first of all -> guarantee that the chars are converted to english
    const filteredAndEnglishedValue = ensureEnglishNumber(value)
    // mask the filtered value, now it is guaranteed to be in english
    const maskedValue = this.maskMobileNumber(filteredAndEnglishedValue)
    this.setState({ maskedValue: maskedValue }, () => {
      shouldUpdateParent &&
        this.props.onChange(this.unMaskMobileNumber(maskedValue))
    })
  }

  shouldApplyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  sendCodeButton = () => (
    <div className="verification-send-code">
      <FormattedMessage id="form.fields.verification.sendCodeButton" />
    </div>
  )

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      required,
      touched,
      error,
      description,
    } = this.props

    const classNames = {
      'formz-phone-Authentication-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-input-title">
            {label} {required && '(*)'}
          </div>
          <RawHtml className="formz-field-description" content={description} />
          <div className="input-wrapper">
            <input
              type="text"
              name={name}
              value={this.getInputValue()}
              className="authentication-phone-field ltr-on-type"
              placeholder={placeholder}
              onChange={this.onInputChange}
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
            />
            {this.sendCodeButton()}
          </div>
        </label>
      </FieldRowWrapper>
    )
  }
}

export default injectIntl(OtpPhoneNumberInput)
